import "core-js/modules/es.array.push.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6cf05818"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "my-page"
};
const _hoisted_2 = {
  class: "my-header"
};
const _hoisted_3 = {
  class: "my-user"
};
const _hoisted_4 = {
  class: "my-avatar"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "my-info"
};
const _hoisted_7 = {
  class: "my-name"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "my-sub"
}, "我的个人主页", -1));
const _hoisted_9 = {
  class: "my-menu"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "row-icon"
}, "👑", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "row-label"
}, "会员时间", -1));
const _hoisted_12 = {
  class: "row-value"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "row-arrow"
}, "›", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "row-icon"
}, "💎", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "row-label"
}, "鲸豆", -1));
const _hoisted_16 = {
  class: "row-value beans-value"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "row-arrow"
}, "›", -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "row-icon"
}, "✏️", -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "row-label"
}, "编辑资料", -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "row-arrow"
}, "›", -1));
const _hoisted_21 = [_hoisted_18, _hoisted_19, _hoisted_20];
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "row-icon"
}, "🔑", -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "row-label"
}, "修改密码", -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "row-arrow"
}, "›", -1));
const _hoisted_25 = [_hoisted_22, _hoisted_23, _hoisted_24];
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "row-icon"
}, "ℹ️", -1));
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "row-label"
}, "关于我们", -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "row-arrow"
}, "›", -1));
const _hoisted_29 = [_hoisted_26, _hoisted_27, _hoisted_28];
const _hoisted_30 = {
  class: "my-footer"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "客服电话 xxx-xxx-xxxx 工作时间 9:30-18:30", -1));
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "浙ICP备2024096554", -1));
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "用户协议隐私政策 | 经营执照 | 防骗指南", -1));
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "popup-title"
}, "编辑资料", -1));
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "popup-title"
}, "修改密码", -1));
import { ref, computed } from 'vue';
import { showNotify } from '@nutui/nutui';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import service from '@/utils/request';
import request from '@/utils/request';
import moment from 'moment';
export default {
  __name: 'MyView',
  setup(__props) {
    const timeNotify = msg => {
      showNotify.warn(msg, {
        duration: 2000
      });
    };
    const successNotify = msg => {
      showNotify.success(msg);
    };
    const store = useStore();
    const router = useRouter();

    // 弹窗统一样式：圆角白底
    const popupStyle = {
      padding: '24px 16px 20px',
      borderRadius: '12px',
      width: '85%'
    };
    const formData = ref({
      nickName: store.state.user?.nickName,
      phonenumber: store.state.user?.phonenumber,
      email: store.state.user?.email,
      sex: store.state.user?.sex
    });
    const formPwd = ref({
      oldPassword: "",
      newPassword: "",
      confirmPassword: ""
    });
    const formRef = ref(null);
    const formPwdRef = ref(null);
    const isVisible = ref(false);
    const isShow = ref(false);

    // 用户信息：computed 跟随 store，编辑/购买后自动刷新
    const user = computed(() => store.state.user || {
      nickName: '未登录',
      avatar: ''
    });
    const nickName = computed(() => user.value.nickName || '未登录');
    // 鲸豆余额
    const beans = computed(() => store.state.user?.beans ?? 0);
    // 会员到期时间
    const fullTime = computed(() => store.state.fullUser && store.state.user?.endDate ? moment(store.state.user.endDate).format('YYYY-MM-DD') : '未开通');
    const logout = async () => {
      const response = await service.post('/logout', {});
      if (response.code == 200) {
        localStorage.removeItem('token');
        store.dispatch('logout');
        // 根据需要重定向到首页或其他页面
        router.push('/login');
      } else {
        timeNotify(response.msg);
      }
      console.log('用户已退出登录');
    };

    // 失去焦点校验
    const customBlurValidate = prop => {
      formRef.value?.validate(prop).then(({
        valid,
        errors
      }) => {
        if (valid) {
          console.log('success:', formData.value);
        } else {
          console.warn('error:', errors);
        }
      });
    };
    const customPwdBlurValidate = prop => {
      formPwdRef.value?.validate(prop).then(({
        valid,
        errors
      }) => {
        if (valid) {
          console.log('success:', formPwd.value);
        } else {
          console.warn('error:', errors);
        }
      });
    };
    const toExplain = () => {
      router.push('/explain');
    };
    const toFullTime = () => {
      router.push('/fullTime');
    };
    const toRecharge = () => {
      router.push('/recharge');
    };
    const openInfo = () => {
      formData.value = {
        nickName: store.state.user?.nickName,
        phonenumber: store.state.user?.phonenumber,
        email: store.state.user?.email,
        sex: store.state.user?.sex
      };
      isVisible.value = true;
    };
    const openPwd = () => {
      formPwd.value = {
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
      };
      isShow.value = true;
    };
    const nameLengthValidator = val => {
      if (val == formPwd.value.newPassword) {
        return Promise.resolve();
      } else {
        return Promise.reject('两次输入的密码不一致');
      }
    };
    const submit = () => {
      formRef.value?.validate().then(({
        valid,
        errors
      }) => {
        if (valid) {
          updateUserProfile();
        } else {
          console.warn('error:', errors);
        }
      });
    };
    const submitPwd = () => {
      formPwdRef.value?.validate().then(({
        valid,
        errors
      }) => {
        if (valid) {
          updateUserPwd();
        } else {
          console.warn('error:', errors);
        }
      });
    };
    const updateUserProfile = async () => {
      // 发送登录请求
      const response = await service.put('/system/user/profile', {
        nickName: formData.value.nickName,
        phonenumber: formData.value.phonenumber,
        email: formData.value.email,
        sex: formData.value.sex
      });
      if (response.code == 200) {
        successNotify("编辑成功");
        getInfo();
        isVisible.value = false;
      } else {
        timeNotify(response.msg);
      }
    };
    const updateUserPwd = async () => {
      // 发送登录请求
      const response = await service.put('/system/user/profile/updatePwd?oldPassword=' + formPwd.value.oldPassword + "&newPassword=" + formPwd.value.newPassword);
      if (response.code == 200) {
        successNotify("修改成功");
        localStorage.setItem('password', formPwd.value.newPassword);
        isShow.value = false;
      } else {
        timeNotify(response.msg);
      }
    };
    const getInfo = () => {
      request.get('/getInfo').then(res => {
        if (res.code == 200) {
          // 登录成功，更新Vuex状态，computed 自动刷新
          store.dispatch('login', res);
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_nut_avatar = _resolveComponent("nut-avatar");
      const _component_nut_button = _resolveComponent("nut-button");
      const _component_nut_input = _resolveComponent("nut-input");
      const _component_nut_form_item = _resolveComponent("nut-form-item");
      const _component_nut_radio = _resolveComponent("nut-radio");
      const _component_nut_radio_group = _resolveComponent("nut-radio-group");
      const _component_nut_form = _resolveComponent("nut-form");
      const _component_nut_popup = _resolveComponent("nut-popup");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_nut_avatar, {
        size: "large",
        style: {
          "border": "2px solid #fff",
          "box-shadow": "0 2px 8px rgba(0,0,0,.15)"
        }
      }, {
        default: _withCtx(() => [user.value.avatar != '' ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: user.value.avatar
        }, null, 8, _hoisted_5)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createTextVNode(_toDisplayString((user.value.nickName || '未登录').charAt(0)), 1)], 64))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(nickName.value), 1), _hoisted_8])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
        class: "menu-row",
        onClick: toFullTime
      }, [_hoisted_10, _hoisted_11, _createElementVNode("span", _hoisted_12, _toDisplayString(fullTime.value), 1), _hoisted_13]), _createElementVNode("div", {
        class: "menu-row",
        onClick: toFullTime
      }, [_hoisted_14, _hoisted_15, _createElementVNode("span", _hoisted_16, _toDisplayString(beans.value), 1), _createElementVNode("span", {
        class: "recharge-btn",
        onClick: _withModifiers(toRecharge, ["stop"])
      }, "充值"), _hoisted_17]), _createElementVNode("div", {
        class: "menu-row",
        onClick: openInfo
      }, _hoisted_21), _createElementVNode("div", {
        class: "menu-row",
        onClick: openPwd
      }, _hoisted_25), _createElementVNode("div", {
        class: "menu-row",
        onClick: toExplain
      }, _hoisted_29)]), _createElementVNode("div", _hoisted_30, [_createVNode(_component_nut_button, {
        class: "logout-btn",
        shape: "square",
        type: "default",
        block: "true",
        onClick: logout
      }, {
        default: _withCtx(() => [_createTextVNode("退出登录")]),
        _: 1
      }), _hoisted_31, _hoisted_32, _hoisted_33])]), _createVNode(_component_nut_popup, {
        visible: isVisible.value,
        "onUpdate:visible": _cache[5] || (_cache[5] = $event => isVisible.value = $event),
        closeable: "",
        style: popupStyle
      }, {
        default: _withCtx(() => [_hoisted_34, _createVNode(_component_nut_form, {
          ref_key: "formRef",
          ref: formRef,
          "model-value": formData.value,
          rules: {
            nickName: [{
              required: true,
              message: '用户昵称不能为空'
            }]
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_nut_form_item, {
            label: "用户昵称",
            prop: "nickName"
          }, {
            default: _withCtx(() => [_createVNode(_component_nut_input, {
              modelValue: formData.value.nickName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value.nickName = $event),
              placeholder: "请输入用户昵称",
              type: "text",
              onBlur: _cache[1] || (_cache[1] = $event => customBlurValidate('nickName'))
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_nut_form_item, {
            label: "手机号码",
            prop: "phonenumber",
            rules: [{
              required: true,
              message: '手机号码不能为空'
            }, {
              regex: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
              message: '请输入正确的手机号码'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_nut_input, {
              modelValue: formData.value.phonenumber,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.value.phonenumber = $event),
              placeholder: "请输入手机号码",
              type: "text"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_nut_form_item, {
            label: "邮箱"
          }, {
            default: _withCtx(() => [_createVNode(_component_nut_input, {
              modelValue: formData.value.email,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.value.email = $event),
              placeholder: "请输入邮箱",
              type: "text"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_nut_form_item, {
            label: "性别"
          }, {
            default: _withCtx(() => [_createVNode(_component_nut_radio_group, {
              modelValue: formData.value.sex,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.value.sex = $event),
              direction: "horizontal"
            }, {
              default: _withCtx(() => [_createVNode(_component_nut_radio, {
                label: "0"
              }, {
                default: _withCtx(() => [_createTextVNode("男")]),
                _: 1
              }), _createVNode(_component_nut_radio, {
                label: "1"
              }, {
                default: _withCtx(() => [_createTextVNode("女")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model-value"]), _createVNode(_component_nut_button, {
          class: "popup-submit",
          type: "primary",
          block: "true",
          onClick: submit
        }, {
          default: _withCtx(() => [_createTextVNode("提交")]),
          _: 1
        })]),
        _: 1
      }, 8, ["visible"]), _createVNode(_component_nut_popup, {
        visible: isShow.value,
        "onUpdate:visible": _cache[10] || (_cache[10] = $event => isShow.value = $event),
        "z-index": 10,
        closeable: "",
        style: popupStyle
      }, {
        default: _withCtx(() => [_hoisted_35, _createVNode(_component_nut_form, {
          ref_key: "formPwdRef",
          ref: formPwdRef,
          "model-value": formPwd.value,
          rules: {
            oldPassword: [{
              required: true,
              message: '旧密码不能为空'
            }]
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_nut_form_item, {
            label: "旧密码",
            prop: "oldPassword"
          }, {
            default: _withCtx(() => [_createVNode(_component_nut_input, {
              modelValue: formPwd.value.oldPassword,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => formPwd.value.oldPassword = $event),
              placeholder: "请输入旧密码",
              type: "password",
              onBlur: _cache[7] || (_cache[7] = $event => customPwdBlurValidate('oldPassword'))
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_nut_form_item, {
            label: "新密码",
            prop: "newPassword",
            rules: [{
              required: true,
              message: '新密码不能为空'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_nut_input, {
              modelValue: formPwd.value.newPassword,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => formPwd.value.newPassword = $event),
              placeholder: "请输入新密码",
              type: "password"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_nut_form_item, {
            label: "确认密码",
            prop: "confirmPassword",
            rules: [{
              required: true,
              message: '确认密码不能为空'
            }, {
              message: '两次输入的密码不一致',
              validator: nameLengthValidator
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_nut_input, {
              modelValue: formPwd.value.confirmPassword,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => formPwd.value.confirmPassword = $event),
              placeholder: "请输入确认密码",
              type: "password"
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["rules"])]),
          _: 1
        }, 8, ["model-value"]), _createVNode(_component_nut_button, {
          class: "popup-submit",
          type: "primary",
          block: "true",
          onClick: submitPwd
        }, {
          default: _withCtx(() => [_createTextVNode("提交")]),
          _: 1
        })]),
        _: 1
      }, 8, ["visible"])], 64);
    };
  }
};